import { type PermissionCode as PermissionCodeType } from '@gb-ticket/shared-types';
import { Loader2Icon } from 'lucide-react';
import { Navigate, Outlet } from 'react-router';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { FLEET_ROOT } from '@/products/fleet/fleet-paths';

export function FleetAdminGate({ permission }: { permission: PermissionCodeType }) {
  const me = useMe();

  if (me.isPending) {
    return (
      <p className="flex items-center gap-2 text-muted-foreground">
        <Loader2Icon className="size-4 animate-spin" aria-hidden />
        Wird geladen …
      </p>
    );
  }

  if (!me.data || !hasPermission(me.data, permission)) {
    return <Navigate to={FLEET_ROOT} replace />;
  }

  return <Outlet />;
}
